<template>
  <div class="onlineofficial">
    <PageHeader v-if="pageSource != 'sx'" @changePages="changePages"></PageHeader>
    <Home v-if="$route.params.type === 'index' || !$route.params.type"></Home>
    <Solution v-if="$route.params.type === 'solution'"></Solution>
    <ServiceCase v-if="$route.params.type === 'case'"></ServiceCase>
    <ServiceSupport v-if="$route.params.type === 'support'"></ServiceSupport>
    <AboutUs v-if="$route.params.type === 'about'"></AboutUs>
    <Fenxiao v-if="$route.params.type === 'fx'"></Fenxiao>
    <Footer v-if="pageSource != 'sx'"></Footer>
  </div>
</template>
<script>
import PageHeader from "@/components/Header.vue";
import Home from './Home.vue'
import Solution from './Solution.vue'
import ServiceCase from './ServiceCase.vue'
import ServiceSupport from './ServiceSupport.vue'
import AboutUs from './AboutUs.vue'
import Fenxiao from './Fenxiao.vue'
import Footer from '@/components/Footer.vue'
export default {
  data() {
    return {
      pageSource: this.$route.query.type // 页面来源 xs数校免费区
    }
  },
  methods: {
    changePages(type) {
      // if (type == 'digital') {
      //   window.open('https://school-web.etiantian.com/#/')
      // } else if (this.$route.params.type !== type) {
      this.$router.push({path: '/ett/'+ type})
      // }
    }
  },
  components: {
    PageHeader,
    Home,
    Solution,
    ServiceCase,
    ServiceSupport,
    AboutUs,
    Fenxiao,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.onlineofficial {
  min-height: 100vh;
  min-width: 960px;
  background: #F7F8F8;
}
</style>
